import { render, staticRenderFns } from "./InvoiceUnbalanceAlert.vue?vue&type=template&id=224076f0&"
import script from "./InvoiceUnbalanceAlert.vue?vue&type=script&lang=js&"
export * from "./InvoiceUnbalanceAlert.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports